import React from "react";
import styles from "./OriStarterPillRow.module.scss";

export interface StarterPillItem {
  key: string;
  label: string;
  testId: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  /** A short line under the label, e.g. "Try something new". */
  caption?: string;
}

interface OriStarterPillRowProps {
  items: StarterPillItem[];
  testId: string;
  onSelect: (index: number) => void;
  disabled: boolean;
}

const OriStarterPillRow: React.FC<OriStarterPillRowProps> = ({
  items,
  testId,
  onSelect,
  disabled,
}) => (
  <div className={styles.pills} data-testid={testId}>
    {items.map(({ key, label, testId: itemTestId, Icon, caption }, index) => (
      <button
        key={key}
        type="button"
        className={styles.pill}
        data-testid={itemTestId}
        disabled={disabled}
        onClick={() => onSelect(index)}
      >
        {Icon && <Icon className={styles.icon} aria-hidden focusable={false} />}
        {caption ? (
          <span className={styles.text}>
            <span>{label}</span>
            <span className={styles.caption}>{caption}</span>
          </span>
        ) : (
          label
        )}
      </button>
    ))}
  </div>
);

export default OriStarterPillRow;
